<template>
  <div class="main-body">
    <div class="header">视频监控</div>
    <div class="out">
      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>
        <el-button size="mini" type="success" plain @click="toggleModalViewPlus">视频预览</el-button>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th"
                @selection-change="handleSelectionChange"
                border >

        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="sn" label="序列号"></el-table-column>
        <el-table-column prop="yzm" label="验证码"></el-table-column>
        <el-table-column prop="tdh" label="通道号"></el-table-column>
        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="RemoveBinding(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small background layout="prev, pager, next"
              :total="totalItems"
              :page-size="pageSize"
              :current-page.sync="currentPage"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


      <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
      <ViewPlus ref="myViewPlus" v-show="showModalViewPlus" v-on:closeViewPlus="closeViewPlus"></ViewPlus>

    </div>
  </div>
</template>

<script>
import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import {getStaffDTO} from "@/utils/auth";

import Add from "./Add";
import ViewPlus from "./ViewPlus";

export default {
  name: "Page",
  data() {
    return {
      tableLoading:false,

      showModalAdd:false,
      showModalViewPlus:false,

      tableData: null,
      totalItems: 0,
      pageSize: 8,
      currentPage: 1,

      th: 0,

      multipleSelection:'',

    };
  },
  components: {Add,ViewPlus},
  created() {
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    toggleModalViewPlus:function(){
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        this.$message({type: 'warning', message: '请选择摄像头'});
        return;
      }

      this.$refs.myViewPlus.init2(this.multipleSelection);
      this.showModalViewPlus = !this.showModalViewPlus;
    },
    closeViewPlus:function(){
      this.showModalViewPlus = !this.showModalViewPlus;
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(){
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "GroupCamera/PageByInstitutionCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          institutionCode:getStaffDTO().institutionDTO.institutionCode,
        },
      }).then((response) => {
            _this.tableLoading=false
            if (response.data.error == 0) {
              this.tableData = response.data.data.list;
              this.totalItems = response.data.data.total;
            } else if (response.data.error == 1) {
              this.$message.error(response.data.message);
            }
          }).catch(function (error) {
            _this.tableLoading=false
            console.log(error);
          });
    },

    //日期格式
    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

    RemoveBinding(row) {
      this.$confirm("您确定要删除该设备吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
            this.$axios({
              method: "post",
              url: this.$deviceUrl + "GroupCamera/Delete",
              data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                groupCameraCode: row.groupCameraCode,
              },
            }).then((response) => {
                  console.log(response);
                  if (response.data.error == 0) {
                    this.$message({message: "删除成功", type: "success",});
                    this.getList();
                  } else if (response.data.error == 1) {
                    this.$message.error(response.data.message);
                  }
                }).catch(function (error) {
                  console.log(error);
                });
          })
          .catch(() => {
            //this.$message({type: "info", message: "已取消操作",});
          });
    },

  },
};
</script>

